module.exports = __webpack_public_path__ + "img/archi.58df4bad.png";